import { render, staticRenderFns } from "./OrderChangesConfirmation.vue?vue&type=template&id=2bf6325c&scoped=true"
import script from "./OrderChangesConfirmation.vue?vue&type=script&lang=js"
export * from "./OrderChangesConfirmation.vue?vue&type=script&lang=js"
import style0 from "./OrderChangesConfirmation.vue?vue&type=style&index=0&id=2bf6325c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf6325c",
  null
  
)

export default component.exports